import axiosClient from "./axios.client";

export const login = (params) => {
    return axiosClient.post('authen/login', params);
}

export const getListAccount = (params) => {
    return axiosClient.post('cms/account/getListAccount', params);
}

export const addNewAccount = (params) => {
    return axiosClient.post('cms/account/addNewAccount', params);
}

export const getListDepartment = (params) => {
    return axiosClient.get(`cms/department/getListDepartment?keyword=${params?.keyword ?? ''}`);
}

export const getListRoles = () => {
    return axiosClient.get('cms/roles/getListRoles');
}

export const updateUserInfo = (params) => {
    return axiosClient.post('cms/account/updateUserInfo', params);
}

export const addNewDepartment = (params) => {
    return axiosClient.post('cms/department/addNewDepartment', params);
}

export const updateDepartmentById = (params) => {
    return axiosClient.post('cms/department/updateDepartmentById', params);
}

export const addNewSuppiler = (params) => {
    return axiosClient.post('cms/suppiler/addNewSuppiler', params);
}

export const updateSuppiler = (params) => {
    return axiosClient.post('cms/suppiler/updateSuppiler', params);
}

export const getListSuppiler = (params) => {
    return axiosClient.get(`cms/suppiler/getListSuppiler?keyword=${params?.keyword ?? ''}`);
}

export const getListOrders = (params) => {
    return axiosClient.post('cms/orders/getListOrders_v2', params);
}

export const createNewTask = (params) => {
    return axiosClient.post('cms/tasks/createNewTask', params);
}

export const getListTaskByOrderId = (params) => {
    return axiosClient.get(`cms/tasks/getListTaskByOrderId?order_id=${params?.order_id}`);
}

export const updateTaskById = (params) => {
    return axiosClient.post('cms/tasks/updateTaskById', params);
}

export const updateTrackingNumberByOrderId = (params) => {
    return axiosClient.post('cms/orders/updateTrackingNumberByOrderId', params);
}

export const showOrderForSupImmediately = (params) => {
    return axiosClient.post('cms/orders/showOrderForSupImmediately', params);
}

export const getListShops = (params) => {
    return axiosClient.get(`cms/shops/getListShops?keyword=${params?.name ?? ''}`);
}

export const getListTypeAction = (params) => {
    return axiosClient.get('cms/tasks/getListTypeAction');
}

export const updateShopById = (params) => {
    return axiosClient.post('cms/shops/updateShopById', params);
}

export const addNewTypeAction = (params) => {
    return axiosClient.post('cms/tasks/addNewTypeAction', params);
}

export const updateTypeAction = (params) => {
    return axiosClient.post('cms/tasks/updateTypeAction', params);
}

export const getListTaskForDesigner = (params) => {
    return axiosClient.post('cms/tasks/getListTaskForDesigner', params);
}

export const getListStaff = () => {
    return axiosClient.get('cms/tasks/getListStaff');
}

export const createNewOrder = (params) => {
    return axiosClient.post('cms/orders/createNewOrder', params);
}

export const convertImageToBase64 = (params) => {
    return axiosClient.get(`convertImageToBase64?image_url=${params?.image_url}`);
}

export const checkAndUpdateSKUForOrder = (params) => {
    return axiosClient.post('cms/orders/checkAndUpdateSKUForOrder', params);
}

export const updateDesignLinkForOrder = (params) => {
    return axiosClient.post('cms/orders/updateDesignLinkForOrder', params);
}

export const getOrdersReport = (params) => {
    return axiosClient.post('cms/reports/getOrdersReport', params);
}

export const reportTaskByStatus = (params) => {
    return axiosClient.post('cms/reports/reportTaskByStatus', params);
}

export const reportTaskByStaff = (params) => {
    return axiosClient.post('cms/reports/reportTaskByStaff', params);
}

export const exportOrderBySupplier = (params) => {
    return axiosClient.post('cms/reports/exportOrderBySupplier', params);
}

export const exportOrderAllForSup = (params) => {
    return axiosClient.post('cms/reports/exportOrderAllForSup', params);
}

export const exportOrderBySelected = (params) => {
    return axiosClient.post('cms/reports/exportOrderBySelected', params);
}

export const exportOrderBySelectedForSup = (params) => {
    return axiosClient.post('cms/reports/exportOrderBySelectedForSup', params);
}

export const changeUserPassword = (param) => {
    return axiosClient.post('authen/changePassword', param);
}

export const updateForMutilOrder = (param) => {
    return axiosClient.post('cms/orders/updateForMutilOrder', param);
}

export const updateForMutilTask = (param) => {
    return axiosClient.post('cms/tasks/updateForMutilTask', param);
}

export const updateSKUInfoToGoogleSheet = (param) => {
    return axiosClient.post('cms/tasks/updateSKUInfoToGoogleSheet', param);
}

export const getOrderDetailById = (params) => {
    return axiosClient.post(`cms/orders/getOrderDetailById`, params);
}

export const getOrderItemDetail = (params) => {
    return axiosClient.post(`cms/orders/getOrderItemDetail`, params);
}

export const updateShippingInfoByOrderId = (params) => {
    return axiosClient.post(`cms/orders/updateShippingInfoByOrderId`, params);
}

export const getListApiKey = (params) => {
    return axiosClient.get(`cms/api_key/getListApiKey?site=${params?.keyword}`);
}

export const deleteApiKey = (params) => {
    return axiosClient.post(`cms/api_key/deleteApiKey`, params);
}

export const editApiKey = (params) => {
    return axiosClient.post(`cms/api_key/editApiKey`, params);
}

export const addNewApiKey = (params) => {
    return axiosClient.post(`cms/api_key/addNewApiKey`, params);
}

export const getListCategories = (params) => {
    return axiosClient.get(`cms/categories/getListCategories?keyword=${params?.keyword ?? ''}`);
}

export const saveLogChangeStatus = (params) => {
    return axiosClient.post(`cms/logs/saveLogChangeStatus`, params);
}

export const getListLogChangeStatus = (params) => {
    return axiosClient.get(`cms/logs/getListLogByOrderId?order_id=${params?.order_id}`);
}

export const getListProvider = (params) => {
    return axiosClient.get(`cms/provider/getListProvider?keyword=${params?.keyword ?? ''}`);
}

export const verifyDataImportTracking = (params) => {
    return axiosClient.post(`cms/import/verifyDataImportTracking`, params);
}

export const updateTrackingNumberFromImport = (params) => {
    return axiosClient.post(`cms/import/updateTrackingNumberFromImport`, params);
}

export const getTrackingStatusByTracknumber = (params) => {
    return axiosClient.post(`cms/orders/getTrackingStatusByTracknumber`, params);
}

export const updateTimeAssignSupplier = (params) => {
    return axiosClient.post('cms/orders/updateTimeAssignSupplier', params);
}

export const saveLogChangeTaskTime = (params) => {
    return axiosClient.post(`cms/logs/saveLogChangeTaskTime`, params);
}

export const getListLogChangeTaskTime = (params) => {
    return axiosClient.get(`cms/logs/getListLogTaskById?task_id=${params?.task_id}`);
}

export const reportPerformanceTask = (params) => {
    return axiosClient.post('cms/reports/reportPerformanceTask', params);
}

export const importDataSku = (params) => {
    return axiosClient.post('cms/sku/importDataSKUWithBaseCost', params);
}

export const importUpdateBaseCost = (params) => {
    return axiosClient.post('cms/sku/importUpdateBaseCost', params);
}

export const getListDataSku = (params) => {
    return axiosClient.post('cms/sku/getListDataSku', params);
}

export const addNewSku = (params) => {
    return axiosClient.post('cms/sku/addNewSku', params);
}

export const updateSkuInfo = (params) => {
    return axiosClient.post('cms/sku/updateSkuInfo', params);
}

export const deleteSkuById = (params) => {
    return axiosClient.post('cms/sku/deleteSkuById', params);
}

export const getSkuDetailById = (params) => {
    return axiosClient.post('cms/sku/getSkuDetailById', params);
}

export const updateOrderItemWithDesign = (params) => {
    return axiosClient.post('cms/design/updateOrderItemWithDesign', params);
}

export const saveDesignInfoToMasterData = (params) => {
    return axiosClient.post('cms/design/saveDesignInfoToMasterData', params);
}

export const verifyShopShopify = (params) => {
    return axiosClient.post('cms/shopify/auth/verifyShop', params);
}

export const getAuthUrl = (params) => {
    return axiosClient.get(`cms/shopify/auth/get-auth-url?shop=${params?.shop}`);
}

export const verifyInstallApp = (params) => {
    return axiosClient.post('cms/shopify/auth/verifyInstall', params);
}

export const getListShopShopify = (params) => {
    return axiosClient.post('cms/shopify/shop/getListShopShopify', params);
}

export const getShopifyApp = (params) => {
    return axiosClient.post('cms/shopify/app/getShopifyApp', params);
}

export const addShopifyShop = (params) => {
    return axiosClient.post('cms/shopify/shop/addShopifyShop', params);
}

export const updateShopShopify = (params) => {
    return axiosClient.post('cms/shopify/shop/updateShopShopify', params);
}

export const addShopifyApp = (params) => {
    return axiosClient.post('cms/shopify/app/addShopifyApp', params);
}

export const updateShopifyApp = (params) => {
    return axiosClient.post('cms/shopify/app/updateShopifyApp', params);
}

export const getInstallLinkById = (params) => {
    return axiosClient.post('cms/shopify/app/getInstallLinkById', params);
}

export const getListWebhookShopify = (params) => {
    return axiosClient.post('cms/shopify/webhook/getListWebhookShopify', params);
}

export const createShopifyOrderWehook = (params) => {
    return axiosClient.post('cms/shopify/webhook/order/createShopifyOrderWehook', params);
}

export const deleteShopifyWebhook = (params) => {
    return axiosClient.post('cms/shopify/webhook/order/deleteShopifyWebhook', params);
}

export const getShopifyProductLink = (params) => {
    return axiosClient.post('cms/shopify/webhook/order/getShopifyProductLink', params);
}

export const getAuthUrlTiktok = () => {
    return axiosClient.get('cms/config/getAuthUrlTiktok');
}

export const verifyAuthCodeShop = (params) => {
    return axiosClient.post('cms/config/authenTiktokShop', params);
}

export const registerTiktokWebhook = (params) => {
    return axiosClient.post('cms/shops/createTiktokShopWebhook', params);
}

export const unsubscribeTiktokWebhook = (params) => {
    return axiosClient.post('cms/shops/unsubscribeTiktokWebhook', params);
}

export const updateOrderItem = (params) => {
    return axiosClient.post('cms/orders/updateOrderItem', params);
}

export const updateOrderById = (params) => {
    return axiosClient.post('cms/orders/updateOrderById', params);
}

export const getShopPerformance = (params) => {
    return axiosClient.post('cms/dashboard/getShopPerformance', params);
}

export const getOrdersChart = (params) => {
    return axiosClient.post('cms/dashboard/getOrdersChart', params);
}

export const updateSupplierByOrderId = (params) => {
    return axiosClient.post('cms/orders/updateSupplierByOrderId', params);
}

export const searchSkuPrintlogistic = (params) => {
    return axiosClient.post('cms/sku/searchSkuPrintlogistic', params);
}

export const updateAndExportOrderBySelected = (params) => {
    return axiosClient.post('cms/orders/updateAndExportOrderBySelected', params);
}

export const exportOrderSelected = (params) => {
    return axiosClient.post('cms/orders/exportOrderSelected', params);
}

export const updateSellerNoteByOrdreId = (params) => {
    return axiosClient.post('cms/orders/updateSellerNoteByOrdreId', params);
}

export const getTransactionByOrderId = (params) => {
    return axiosClient.post('cms/orders/getTransactionByOrderId', params);
}

export const filterOrdersBySeller = (params) => {
    return axiosClient.post('cms/orders/filterOrdersBySeller', params);
}

export const exportOrdersBySeller = (params) => {
    return axiosClient.post('cms/orders/exportOrdersBySeller', params);
}

export const getTop10BestSellers = (params) => {
    return axiosClient.post('cms/orders/getTop10BestSellers', params);
}
